const canSellFromCountry = country => country === 'GR';

const isSellingRoute = (name, params = {}) =>
  ['NewListingPage', 'NewListingPageWithcategory', 'CategoryPage'].includes(name) ||
  (['EditListingPage', 'EditListingStripeOnboardingPage'].includes(name) &&
    ['new', 'draft'].includes(params.type));

const isSellingPath = href => {
  if (typeof href !== 'string') return false;
  try {
    const path = new URL(href, 'https://marketplace.invalid').pathname;
    return (
      /^\/(?:l\/new|category)\/?$/.test(path) ||
      /^\/listing\/create\//.test(path) ||
      /^\/l\/[^/]+\/[^/]+\/(?:new|draft)\//.test(path)
    );
  } catch (error) {
    return false;
  }
};

module.exports = { canSellFromCountry, isSellingRoute, isSellingPath };
